var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('pf-header'),_c('pf-headerprofilecards'),_c('pf-presentationcard'),_c('pf-toolsusedcard'),_c('pf-cardprojects'),_c('pf-gallery'),_c('pf-professionalexperience'),_c('pf-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }